import {COLORS, SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import coinsWalletBackground from '../../../features/Coins/assets/background-dark.png';
import {useIsMissionsActive} from '../../../features/Coins/utils/useIsMissionsActive';

export const CoinsSkeletons: React.FC = () => {
  const isMissionsActive = useIsMissionsActive();

  return (
    <Wrapper data-is-missions-active={isMissionsActive}>
      <Header>
        {/* tabs */}
        {!isMissionsActive && (
          <Flex style={{marginBottom: '20px'}}>
            <DarkSkeletonBlock $width="20%" $height="30px" />
            <DarkSkeletonBlock $width="20%" $height="30px" />
          </Flex>
        )}
        {/* available coins */}
        <DarkSkeletonBlock
          $width="50%"
          $height="80px"
          disableSpaceBelow
          style={{marginBottom: '8px'}}
        />
        {/* pending coins */}
        <DarkSkeletonBlock
          $width="30%"
          $height="18px"
          style={{marginBottom: '44px'}}
          disableSpaceBelow
        />
        {/* progress bar */}
        {!isMissionsActive && (
          <>
            <ProgressBar
              $width="85%"
              $height="12px"
              disableSpaceBelow
              style={{marginBottom: '8px'}}
            />

            <DarkSkeletonBlock $width="30%" $height="18px" disableSpaceBelow />
          </>
        )}
      </Header>
      <Body>
        {/* levels */}
        {!isMissionsActive && (
          <Flex>
            <SkeletonBlock $width="100%" $height="82px" />
            <SkeletonBlock $width="100%" $height="82px" />
            <SkeletonBlock $width="100%" $height="82px" />
          </Flex>
        )}
        {/* missions/levels */}
        <SkeletonBlock
          $width="100%"
          $height={`${isMissionsActive ? '40vh' : '316px'}`}
          disableSpaceBelow
        />
        {/* faq */}
        {isMissionsActive && (
          <SkeletonBlock
            $width="100%"
            $height={`${isMissionsActive ? '30vh' : '316px'}`}
            disableSpaceBelow
          />
        )}
        {/* coins history */}
        <SkeletonBlock $width="100%" $height="84px" disableSpaceBelow />
        {/* help center */}
        <SkeletonBlock
          $width="100%"
          $height="84px"
          style={{marginTop: '-16px'}}
          disableSpaceBelow
        />
      </Body>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;

const Flex = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  width: 100%;
`;

export const DarkSkeletonBlock = styled(SkeletonBlock)`
  background-image: linear-gradient(to right, #474747, #2a2a2d 47%, #474747);

  &:before {
    background: linear-gradient(
      90deg,
      transparent,
      ${COLORS['Fill.Black']},
      transparent
    );
  }
`;

const Header = styled.div`
  background-image: url(${coinsWalletBackground});
  background-size: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 48px 0;

  [data-is-missions-active='true'] & {
    padding: 20px 0;
  }
`;

const ProgressBar = styled(DarkSkeletonBlock)`
  border-radius: 8px;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 1;
  margin-top: -20px;
  padding: 32px 16px;
  border-radius: 16px 16px 0px 0px;
  background-color: ${COLORS.White};
  z-index: 1;

  [data-is-missions-active='true'] & {
    padding: 16px;
  }
`;
